/* Industrialsafety-UK — product page: gallery, length stepper, weight, buy now, variants, accordions, tabs, sticky bar (1-10-2026). */
(function () {
  var root = document.querySelector('[data-isu-pdp]');
  if (!root) return;
  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };

  /* gallery */
  var slides = $$('.isu-gal__slide'), thumbs = $$('[data-show]');
  thumbs.forEach(function (b) {
    b.addEventListener('click', function () {
      var k = b.getAttribute('data-show');
      slides.forEach(function (s) { s.classList.toggle('is-on', s.getAttribute('data-slide') === k); });
      thumbs.forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    });
  });

  /* length / quantity */
  var qty = $('[data-isu-qty]');
  var linear = root.getAttribute('data-linear') === 'true';
  var w = parseFloat(root.getAttribute('data-weight'));
  var chips = $$('[data-isu-set]');
  var sync = function () {
    var n = Math.max(1, parseInt(qty.value, 10) || 1);
    if (String(n) !== qty.value) qty.value = n;
    $$('[data-isu-addn]').forEach(function (e) { e.textContent = n; });
    chips.forEach(function (c) { c.classList.toggle('is-on', parseInt(c.getAttribute('data-isu-set'), 10) === n); });
    var sum = $('[data-isu-sum]'); if (sum) sum.textContent = n + ' m in total';
    var kg = $('[data-isu-kg]'); if (kg && w > 0) kg.textContent = '≈ ' + (Math.round(w * n * 100) / 100).toFixed(2) + ' kg';
  };
  if (qty) {
    qty.addEventListener('input', sync);
    qty.addEventListener('change', sync);
    $$('[data-isu-step]').forEach(function (b) {
      b.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-isu-step'), 10)); sync(); });
    });
    chips.forEach(function (c) { c.addEventListener('click', function () { qty.value = c.getAttribute('data-isu-set'); sync(); }); });
  }

  /* buy now = add + go to checkout */
  var form = $('#isu-pf'), ret = $('[data-isu-return]'), now = $('[data-isu-now]'), add = $('[data-isu-add]');
  if (now && ret) {
    now.addEventListener('click', function () { ret.disabled = false; });
    if (add) add.addEventListener('click', function () { ret.disabled = true; });
  }

  /* variants (only products with more than one) */
  var idIn = $('[data-isu-id]'), price = $('[data-isu-price]');
  $$('[data-isu-variant]').forEach(function (b, i, all) {
    b.addEventListener('click', function () {
      all.forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      idIn.value = b.getAttribute('data-isu-variant');
      if (price) price.textContent = b.getAttribute('data-price');
      var ok = b.getAttribute('data-available') === 'true';
      if (add) { add.disabled = !ok; if (!ok) add.textContent = 'Sold out'; else add.innerHTML = '<span>' + (linear ? 'Add <span data-isu-addn>' + qty.value + '</span> m to basket' : 'Add to basket') + '</span>'; }
      if (now) now.hidden = !ok;
      try { var u = new URL(location.href); u.searchParams.set('variant', idIn.value); history.replaceState(null, '', u.toString()); } catch (e) {}
    });
  });

  /* accordions: open on desktop, collapsible on mobile */
  var mq = window.matchMedia('(min-width: 750px)');
  var accs = $$('[data-isu-acc]');
  var setAcc = function () { if (mq.matches) accs.forEach(function (d) { d.open = true; }); };
  setAcc();
  if (mq.addEventListener) mq.addEventListener('change', setAcc);
  accs.forEach(function (d) {
    var s = d.querySelector('summary');
    if (s) s.addEventListener('click', function (e) { if (mq.matches) e.preventDefault(); });
  });

  /* reviews: show all */
  var more = $('[data-isu-more]');
  if (more) more.addEventListener('click', function () {
    $$('[data-isu-revs] li').forEach(function (li) { li.hidden = false; li.classList.add('is-open'); });
    more.remove();
  });

  /* in-page tab highlight */
  var links = $$('.isu-tabs a');
  if ('IntersectionObserver' in window && links.length) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        links.forEach(function (a) { a.classList.toggle('is-on', a.getAttribute('href') === '#' + e.target.id); });
      });
    }, { rootMargin: '-30% 0px -60% 0px' });
    links.forEach(function (a) { var t = document.getElementById(a.getAttribute('href').slice(1)); if (t) io.observe(t); });
  }

  /* sticky add-to-basket on mobile */
  var bar = $('[data-isu-sticky]');
  if (bar && add) {
    var tick = false;
    var check = function () { tick = false; bar.hidden = add.getBoundingClientRect().bottom > 0; };
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(check); } }, { passive: true });
    window.addEventListener('resize', check);
    check();
    var sb = $('[data-isu-stickyadd]', bar);
    if (sb) sb.addEventListener('click', function () { if (ret) ret.disabled = true; if (form.requestSubmit) form.requestSubmit(add); else add.click(); });
  }

  /* contact form result: bring it into view */
  var f = $('[data-isu-focus]');
  if (f) { f.scrollIntoView({ block: 'center' }); f.focus({ preventScroll: true }); }

  if (qty) sync();
})();

/* sort size buttons by their numbers (25.4 × 4.8 …) */
(function () {
  var box = document.querySelector('[data-isu-sizes]');
  if (!box) return;
  var nums = function (el) { var b = el.querySelector('b'); return ((b && b.textContent) || '').split('×').map(function (x) { return parseFloat(x) || 0; }); };
  var items = Array.prototype.slice.call(box.children);
  items.sort(function (a, b) { var x = nums(a), y = nums(b); for (var i = 0; i < Math.max(x.length, y.length); i++) { var d = (x[i] || 0) - (y[i] || 0); if (d) return d; } return 0; });
  items.forEach(function (el) { box.appendChild(el); });
  var on = box.querySelector('.is-on'); if (on && box.scrollWidth > box.clientWidth) box.scrollLeft = on.offsetLeft - 16;
})();
